/**
 * @generated SignedSource<<f19cac1b985d90e3389561e769dbdeea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionSecondChanceOffer_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPurchaseButton_item" | "PriceDisplay_item">;
  readonly " $fragmentType": "PdpSharedAuctionSecondChanceOffer_item";
};
export type PdpSharedAuctionSecondChanceOffer_item$key = {
  readonly " $data"?: PdpSharedAuctionSecondChanceOffer_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionSecondChanceOffer_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionSecondChanceOffer_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPurchaseButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "c7f7d5c652bd7f5d75e8ca92defaffe3";

export default node;
